import Css from "./style.module.scss";

import dropBox from "assets/dropBox.svg";

import { Button } from "shards-react";
import { bind, memoize } from "decko";
import { connect } from "react-redux";
import { getTextsData } from "selectors/texts";
import DocumentFileTypes from "const/DocumentFileTypes";
import DropboxChooser from "react-dropbox-chooser";
import Environment from "utils/Environment";
import React, { PureComponent } from "react";
import Texts from "utils/Texts";

const mapStateToProps = (state) => ({
  textsData: getTextsData(state)
});

@connect(mapStateToProps)
class DropBoxPicker extends PureComponent {
  static SERVICE_NAME = "Dropbox";

  @memoize
  getFileDropAllowedExtensions() {
    return Object.values(DocumentFileTypes).reduce(
      (aggregator, { extensions }) => {
        return [...aggregator, ...extensions];
      },
      []
    );
  }

  @bind
  successCallback(files) {
    files = files.map((file) => {
      const extension = `.${file.link.split(".").pop().toLowerCase()}`;

      const { mimeType } = Object.values(DocumentFileTypes).find(({ extensions }) => extensions.includes(extension));

      return { ...file, mimeType };
    });
    this.props.onFilesPicked(files);
  }

  render() {
    const { DROPBOX_APP_KEY } = Environment.getProcessEnvVars();

    const { textsData: { uiTexts } } = this.props;

    const title = Texts.replaceVars(
      uiTexts.uploadDocumentsFromService,
      { service: DropBoxPicker.SERVICE_NAME }
    );

    return (
      <DropboxChooser
        multiselect
        linkType="direct"
        appKey={DROPBOX_APP_KEY}
        success={this.successCallback}
        extensions={this.getFileDropAllowedExtensions()}>
        <Button
          theme="light"
          title={title}
          className={Css.dropBoxPicker}>
          <img src={dropBox} alt={DropBoxPicker.SERVICE_NAME} />
          <span>{DropBoxPicker.SERVICE_NAME}</span>
        </Button>
      </DropboxChooser>
    );
  }
}

export default DropBoxPicker;
